import { styled } from 'styled-components';

import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';
import { GRADIENTS } from '@components/web/src/styles';

export const ProductRateCardContainer = styled(Flexbox)`
  border-radius: 8px;
  background: ${GRADIENTS.characterGradient};
`;

export const ProductRateImagesPreloadContainer = styled(Flexbox)`
  position: absolute;
  display: none;
`;
